import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditNoteIcon from '@mui/icons-material/EditNote';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import HistoryIcon from '@mui/icons-material/History';
import { AppBar, Box, Grid, Stack, Toolbar, Typography } from '@mui/material';
import { LanguageDropdownList, NavBtn } from 'components';
import { routes } from 'configs';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useSystemActions, useToken, useVerify } from 'stores';

const HeaderTitle = (props: { titleType: number; titleContent?: string }) => {
	const { t } = useTranslation();
	const { getImage } = useSystemActions();

	switch (props.titleType) {
		case 1:
			const logo =
				props.titleContent || process.env.REACT_APP_CUSTOM_LOGO;
			if (!logo) return <></>;
			return (
				<Box
					component="img"
					sx={{
						width: '65%',
						maxHeight: '50px',
						objectFit: 'contain',
					}}
					alt="logo"
					src={getImage(logo)}
				/>
			);
		case 2:
			return (
				<Typography
					sx={{
						fontSize: '1.2rem',
						fontWeight: 'bold',
						color: 'defaultText.main',
					}}
				>
					{t(props.titleContent || '')}
				</Typography>
			);
		case 0:
		default:
			return <></>;
	}
};

const HeaderLeftBtn = (props: { leftBtnType: number }) => {
	switch (props.leftBtnType) {
		case 1:
			return <></>;
		case 2:
			return <LanguageDropdownList />;
		case 0:
		default:
			return (
				<NavBtn>
					<ArrowBackIosNewIcon />
				</NavBtn>
			);
	}
};

const HeaderRightBtn = () => {
	const location = useLocation();
	const { userToken } = useToken();
	const verify = useVerify();
	const code = verify?.code;
	const status = verify?.status;

	const renderHeaderRightBtn = () => {
		switch (location.pathname) {
			case '/Product':
				return (
					<>
						{code &&
						status === 'success' &&
						[
							'msg_code_single_success',
							'msg_code_single_ordinary',
						].indexOf(code) === -1 &&
						process.env.REACT_APP_DISABLE_AUTHINFO !== 'true' ? (
							<NavBtn to={'/AuthInfo'}>
								<HelpRoundedIcon />
							</NavBtn>
						) : null}
						{userToken ? (
							<NavBtn to={'/FeedbackHistory'}>
								<EditNoteIcon />
							</NavBtn>
						) : null}
					</>
				);
			case '/FeedbackHistory':
				return (
					<>
						<NavBtn to={'/Feedback'}>
							<AddIcon />
						</NavBtn>
					</>
				);
			case '/Redeem':
				return (
					<>
						<NavBtn to={'/PointHistory'}>
							<HistoryIcon />
						</NavBtn>
					</>
				);
			default:
				return null;
		}
	};

	return (
		<>
			<Stack direction="row" spacing={0.5}>
				{renderHeaderRightBtn()}
			</Stack>
		</>
	);
};

const Header = () => {
	const location = useLocation();

	let routeObj = routes.find((route) => route.path === location.pathname);
	if (!routeObj) routeObj = routes[routes.length - 1];
	const titleType = routeObj.header.titleType || 0;
	const titleContent = routeObj.header.titleContent;
	const leftBtnType = routeObj.header.leftBtnType || 0;

	return (
		<>
			<AppBar
				sx={{
					position: 'static',
					backgroundColor: 'transparent',
					boxShadow: 'none',
					width: '100%',
					maxWidth: 'sm',
				}}
			>
				<Toolbar>
					<Grid container marginLeft={0}>
						<Grid
							container
							item
							xs={2}
							justifyContent="left"
							alignItems="center"
						>
							<HeaderLeftBtn leftBtnType={leftBtnType} />
						</Grid>
						<Grid
							container
							item
							xs={8}
							justifyContent="center"
							alignItems="center"
						>
							<HeaderTitle
								titleType={titleType}
								titleContent={titleContent}
							/>
						</Grid>
						<Grid
							container
							item
							xs={2}
							justifyContent="flex-end"
							alignItems="center"
						>
							<HeaderRightBtn />
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
		</>
	);
};

export default Header;
